// The per-run JSON log: one file per labeled run, plus one startup file per
// launch (kind "startup", no frames). This is the in-app record that grades
// iOS and cross-checks Android.

export const RUN_SCHEMA = 'gate1.run.v1'

export const LABEL_RE = /^[A-Za-z0-9._-]{1,48}$/

// Android trace marker name. ':' separates the parts because atrace lines are
// themselves '|'-separated ("S|pid|name|cookie"): a '|' in the name breaks
// Perfetto's parser and the marker is lost. LABEL_RE keeps ':' out of labels.
export function traceName({ label, commit, buildType, mode }) {
    return `gate1:${label}:${commit}:${buildType}:${mode}`
}

export function parseTraceName(name) {
    const p = String(name).split(':')
    if (p[0] !== 'gate1' || p.length < 5) return null
    return { label: p[1], commit: p[2], buildType: p[3], mode: p[4] }
}

export function logFileName({ kind, label, epochMs }) {
    const d = new Date(epochMs)
    const z = n => String(n).padStart(2, '0')
    const stamp = `${d.getUTCFullYear()}${z(d.getUTCMonth() + 1)}${z(d.getUTCDate())}-${z(d.getUTCHours())}${z(d.getUTCMinutes())}${z(d.getUTCSeconds())}Z`
    return kind === 'run' ? `run-${label}-${stamp}.json` : `startup-${stamp}.json`
}

// Fields every log must carry; validateRunLog() checks them.
const REQUIRED = {
    common: [
        'schema', 'kind', 'build.commit', 'build.buildType', 'device.model', 'device.osVersion',
        'device.webViewVersion', 'screen.width', 'screen.height', 'screen.devicePixelRatio',
        'crashCounter.counts', 'crashCounter.events',
    ],
    run: [
        'runLabel', 'mode', 'status', 'run.perfStartMs', 'run.perfStopMs', 'run.durationMs',
        'frames.count', 'frames.capacity', 'frames.overflow', 'frames.timestampsMs', 'renderer.ticker.maxFPS',
    ],
    startup: ['startup.marks'],
}

function get(o, path) {
    return path.split('.').reduce((x, k) => (x == null ? undefined : x[k]), o)
}

export function validateRunLog(log) {
    const problems = []
    if (log?.schema !== RUN_SCHEMA) problems.push(`schema is ${log?.schema}`)
    const paths = [...REQUIRED.common, ...(REQUIRED[log?.kind] ?? [])]
    for (const p of paths) if (get(log, p) === undefined) problems.push(`missing ${p}`)
    if (log?.kind === 'run') {
        const ts = log.frames?.timestampsMs ?? []
        if (ts.length !== log.frames?.count) problems.push('frames.count does not match timestamps')
        for (let i = 1; i < ts.length; i++) if (ts[i] < ts[i - 1]) { problems.push(`timestamps not ascending at ${i}`); break }
        if (log.renderer?.ticker?.maxFPS !== 0) problems.push('ticker.maxFPS is not 0 (frame cap active)')
    }
    return problems
}
